import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

// Connects to data-controller="bank-accounts--balance-trend"
// Renders one read-only sparkline of the workspace's reconstructed daily
// balance (see BankAccounts::BalanceTimelineQuery). Visual config mirrors
// receivables_overview_controller.js exactly.
export default class extends Controller {
  static targets = ["canvas"]
  static values = { series: Array }

  connect() {
    this.#render()
  }

  disconnect() {
    this.chart?.destroy()
    this.chart = null
  }

  #render() {
    const data = this.seriesValue
    if (!Array.isArray(data) || data.length < 2) return

    const canvas = this.hasCanvasTarget ? this.canvasTarget : this.element.querySelector("canvas")
    if (!canvas) return
    const context = canvas.getContext("2d")
    if (!context) return

    const gradient = context.createLinearGradient(0, 0, 0, canvas.height || 48)
    gradient.addColorStop(0, "rgba(105, 65, 198, 0.12)")
    gradient.addColorStop(0.62, "rgba(105, 65, 198, 0.045)")
    gradient.addColorStop(1, "rgba(105, 65, 198, 0)")

    this.chart = new Chart(context, {
      type: "line",
      data: {
        labels: data.map((_, index) => index + 1),
        datasets: [
          {
            data,
            borderColor: "#6941C6",
            borderWidth: 1.5,
            backgroundColor: gradient,
            fill: true,
            tension: 0.18,
            cubicInterpolationMode: "monotone",
            pointRadius: 0
          }
        ]
      },
      options: {
        animation: { duration: 0 },
        plugins: { legend: { display: false }, tooltip: { enabled: false } },
        maintainAspectRatio: false,
        responsive: true,
        scales: { x: { display: false }, y: { display: false } },
        elements: { point: { radius: 0 } }
      }
    })
  }
}
